import { debounce } from 'lodash';
import Vue from 'vue';

const escTrackSend = debounce((hasModal) => {
  Vue.prototype.$track.send('Hotkeys', {
    Hotkeys_Scope: '全局',
    Hotkeys_Name: 'Escape',
    Has_Dialog: !!hasModal
  }, true);
}, 300);

export default class Shortcuts {
  constructor(options = {}) {
    this.keyMap = new Set();
    this.time = options.time || 2000;
    this.mods = [];
    this.bindKeyDown = this.keyDown.bind(this);
    this.bindMove = this.mousemoveInfo.bind(this);
    this.isRegister = false;
  }
  register() {
    if (this.isRegister) {
      return;
    }
    this.remove();
    document.addEventListener('keydown', this.bindKeyDown, false);
    document.addEventListener('mousemove', this.bindMove, false);
    console.log('shortcuts register');
    this.isRegister = true;
  }
  remove() {
    document.removeEventListener('keydown', this.bindKeyDown, false);
    document.removeEventListener('mousemove', this.bindMove, false);
    this.isRegister = false;
  }
  checkModal() {
    const modal = document.body.querySelector('.v-modal');
    return modal;
  }
  checkIsUserGuding() {
    return !!document.querySelector('.themes-preview-reflect-backdrop');
  }
  checkIsShareKanban() {
    return !!document.querySelector('.zk-kanban-share-index');
  }
  clearCacheMod() {
    this.mods.length = 0;
    this.mods = [];
  }
  checkMetaOrCtrlKey(e) {
    return e.metaKey || e.ctrlKey;
  }
  filterInput(event) {
    const target = event.target || event.srcElement;
    const { tagName } = target;
    let flag = false;
    if (
      target.isContentEditable
      || ((tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') && !target.readOnly)
    ) {
      flag = true;
    }
    return flag;
  }
  keyDown(e) {
    const isUserGuding = this.checkIsUserGuding();
    if (isUserGuding){
      return;
    }
    const isShareKanban = this.checkIsShareKanban();
    if (isShareKanban){
      return;
    }
    const hasModal = this.checkModal();
    const hasFocusInput = this.filterInput(e);
    //  dialog esc 特殊处理
    if (e.key === 'Escape') {
      escTrackSend(hasModal);

      if (
        hasModal &&
        hasFocusInput
      ) {
        e.stopPropagation();
        return;
      }
    }
    if (this.checkHasDriver() || hasFocusInput) {
      return;
    }

    if (!(this.keyMap instanceof Set)) {
      return;
    }

    const now = (new Date()).getTime();
    this.mods = this.mods.filter(i => {
      return (now - i.timeStamp) <= this.time;
    });
    this.mods.push({
      key: e.key,
      timeStamp: now
    });
    //  返回符合的按键
    const findList = [...this.keyMap].filter(i => {
      // 类型为 global 时，不能存在弹窗
      if (i.type === 'global' && hasModal) {
        return false;
      }
      // 类型为 dialog 时，必须存在弹窗
      if (i.type === 'dialog' && !hasModal) {
        return false;
      }
      // 单个按键 's'
      if (typeof i.key === 'string' && !this.checkMetaOrCtrlKey(e)) {
        return i.key.toUpperCase() === e.key.toUpperCase();
      }
      // demo alt + shift + a
      if (i.key instanceof Array && i.key.includes(16) && i.key.includes(18)) {
        if (e.altKey && e.shiftKey) {
          const k = i.key.filter(c => c !== 16 && c !== 18);
          const r = k[0] === e.keyCode;
          if (r) {
            // webim 在打开过一次后，没有阻止冒泡会导致输入框有 Å
            e.stopPropagation();
            e.preventDefault();
          }

          return r;
        }
        return false;
      }
      // 多个按键 ['g', 'h'] || ['cmd', 's']
      if (i.key instanceof Array) {
        if (i.key.includes('cmd') && !this.checkMetaOrCtrlKey(e)) {
          return false;
        }
        return i.key.every((key, index) => {
          const key2 = this.mods[this.mods.length - (i.key.length - index)]?.key.toUpperCase();
          if (key === 'cmd' && this.checkMetaOrCtrlKey(e)) {
            return true;
          }
          return key.toUpperCase() === key2;
        });
      }
    });

    if (findList.length < 1) {
      return;
    }
    this.clearCacheMod();

    // 根据顺序排列，确定 callback 执行顺序
    findList.sort((item1, item2) => {
      const i1 = item1.sort || 0;
      const i2 = item2.sort || 0;
      return i1 - i2;
    });
    // 循环执行
    findList.every(async item => {
      const result = await item.callback(e);
      return (result !== false);
    });
  }
  addKeyMap(keyMap = []) {
    keyMap.forEach(item => {
      this.keyMap.add(item);
    });
  }
  removeKeyMap(keyMap = []) {
    keyMap.forEach(item => {
      this.keyMap.delete(item);
    });
  }
  getMouseEvent() {
    return this.mouseEvent;
  }
  mousemoveInfo(e) {
    this.mouseEvent = e;
  }
  // 检测是否存在指引
  checkHasDriver() {
    const el = document.querySelector('#driver-page-overlay');
    return el && el.style.display !== 'none';
  }
}
